<y42-context-menu-color-button
  [color]="highlight"
  [faIcon]="['fas', 'font']"
  [inverse]="true"
  [addBackground]="true"
  [nullable]="true"
  tooltip="Highlight"
  (colorChanged)="highlightChanged.emit($event)"
></y42-context-menu-color-button>
